<div class="m-portlet">
    <div class="m-portlet__head">
        <div class="m-portlet__head-progress">
            <!-- here can place a progress bar-->
            <mat-progress-bar mode="indeterminate" *ngIf="viewLoading"></mat-progress-bar>
        </div>
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <span class="m-portlet__head-icon m--hide">
                    <i class="la la-gear"></i>
                </span>
                <h3 class="m-portlet__head-text">
                    {{data.title}}
                </h3>
            </div>
        </div>
    </div>
    <div class="m-form">
        <div class="m-portlet__body">
            <div class="m-form__section m-form__section--first">
                <div class="form-group m-form__group row">
                    <div class="col-lg-12">
                        {{ viewLoading ? data.waitDesciption : data.description}}
                    </div>
                    <div class="col-lg-12 m-form__group-sub">
                        <mat-form-field class="example-full-width" appearance="outline">
                            <mat-label>İptal Sebebi</mat-label>
                            <textarea matInput rows="7" placeholder="İptal Sebebi Giriniz"
                                [formControl]="form.controls['MESAJ']" maxlength="250" required></textarea>
                        </mat-form-field>
                        <small *ngIf="form.controls['MESAJ'].hasError('required') && form.controls['MESAJ'].touched"
                            class="text-danger font-14">
                            {{data.entityTitle}} boş bırakılamaz!</small>
                    </div>
                    <div class="col-lg-12">
                        <span> İptal sebebi olarak maksimum 250 karakter girebilirsiniz. </span>
                    </div>
                    <br />
                    <br />
                    <div class="col-lg-12"
                        *ngIf="loginTipi == enmLoginTipleri.makbuzTek || loginTipi == enmLoginTipleri.turkMakbuz">
                        <span>
                            <b>
                                İPTAL ettiğiniz makbuzun e-Defter beyan sistemine kaydı yapıldıysa
                                <a href="https://portal.defterbeyan.gov.tr/auth/login"
                                    target="_blank">https://portal.defterbeyan.gov.tr/auth/login</a>
                                adresinden giriş yaparak İPTAL edilmesi gerekmektedir.
                            </b>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit text-right">
            <div class="m-form__actions m-form__actions--sm">
                <button mat-button (click)="onYesClick()" [disabled]="!form.valid" color="primary" cdkFocusInitial
                    [disabled]="viewLoading">EVET</button>
                <button mat-button (click)="onNoClick()">HAYIR</button>&nbsp;
            </div>
        </div>
    </div>
</div>